module.exports = __webpack_public_path__ + "static/img/ic_shidu.3438395.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ic_shidu.png
// module id = wMI9
// module chunks = 1